// extracted by mini-css-extract-plugin
export default {"helpIcon":"helpIcon_helpIcon__o2ejp"};